function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M292.5 -421.1C642.039 -421.1 932.452 -161.989 981.144 173.638C888.977 159.726 744.64 151.031 520.309 145.814C475.095 65.8199 388.145 13.6499 292.5 13.6499C196.855 13.6499 109.905 65.8199 64.691 145.814C-159.64 151.031 -303.977 159.726 -396.144 173.638C-347.452 -161.989 -57.0391 -421.1 292.5 -421.1ZM292.5 -508.05C-140.511 -508.05 -490.05 -158.511 -490.05 274.5C-490.05 281.456 -490.05 286.673 -490.05 293.629C-481.355 258.849 -199.637 237.981 123.817 232.764C142.946 156.248 210.767 100.6 292.5 100.6C374.233 100.6 442.054 156.248 461.183 232.764C782.898 237.981 1066.35 257.11 1075.05 293.629C1075.05 286.673 1075.05 281.456 1075.05 274.5C1075.05 -158.511 725.511 -508.05 292.5 -508.05Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M68.1658 406.665C113.38 484.92 198.591 535.351 292.497 535.351C386.403 535.351 469.875 484.92 516.828 406.665C758.549 411.882 897.669 424.055 968.968 434.489C895.93 745.77 617.69 970.101 292.497 970.101C-32.6961 970.101 -310.936 745.77 -383.974 436.228C-312.675 424.055 -173.555 411.882 68.1658 406.665ZM123.814 319.715C-175.294 324.932 -441.361 342.322 -484.836 373.624C-434.405 757.943 -105.734 1057.05 292.497 1057.05C690.728 1057.05 1019.4 759.682 1068.09 373.624C1024.62 342.322 760.288 324.932 459.441 319.715C440.312 394.492 372.491 448.401 290.758 448.401C212.503 448.401 144.682 392.753 123.814 319.715Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M292.5 396.23C359.73 396.23 414.23 341.73 414.23 274.5C414.23 207.27 359.73 152.77 292.5 152.77C225.27 152.77 170.77 207.27 170.77 274.5C170.77 341.73 225.27 396.23 292.5 396.23Z",
  fill: "black"
});

function SvgPokeball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1162,
    height: 1144,
    viewBox: "0 0 1162 1144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokeball);
export default __webpack_public_path__ + "static/media/Pokeball.5253c061.svg";
export { ForwardRef as ReactComponent };